// Site Check UI feature switches.
// Set this to false to immediately restore the legacy View Inspection route
// without removing the workspace/grid-state improvements.
export const SITE_CHECK_WORKSPACE_ENABLED = true;

export const SITE_CHECK_DEFAULT_PAGE_SIZE = 25;
export const SITE_CHECK_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, "all"];
